/*
 * Averagely a single word contains 3-7 letters.
 * And people can read 12 words in 5 sec.
 * Therefore, required average interval to read notification
 * will be calculated as below.
 * Assume that message.length === N, and people can read 60 letters in 5 sec
 * (12 words in 5 sec and 1 word contains 5 letters).
 * 60 letters in 5 sec, therefore 12 letters in 1 sec.
 * Since N / 12 sec is required at least, interval = parseInt(N / 12 * 1000).
 * However, it's good to set minimum/maximum interval.
 * Min -> 1.5 sec, 3.0 sec(warning), Max -> 10.0 sec
 */

function getMessageLifetime (
  messageLength,
  isWarning = false,
  minInterval = 1600,
  minWarningInterval = 3000,
  maxInterval = 10000,
  maxWarningInterval = 10000,
  lettersPerSec = 12,
) {
  const interval = parseInt(messageLength / lettersPerSec) * 1000;
  const maxInterval_ = isWarning ? maxWarningInterval : maxInterval;
  const minInterval_ = isWarning ? minWarningInterval : minInterval;

  return Math.min(Math.max(minInterval_, interval), maxInterval_);
}


const ClickCounter = class ClickCounterImpl {
  constructor (keys, interval = 300) {
    this.interval = interval;
    this.keys = [...keys];
    this.clearCounts();
    this.clearTimer();
  }

  clearCounts (keyToExclude) {
    this.counts = this.keys.reduce((result, key) => {
      if (key != keyToExclude) {
        result[key] = 0;
      }
      return result;
    }, {});
  }

  clearTimer () {
    clearTimeout(this.timerId);
    this.timerId = null;
  }

  clear () {
    this.clearCounts();
    this.clearTimer();
  }

  click (key) {
    this.clearTimer();

    if (this.keys.includes(key)) {
      this.counts[key]++;
    } else {
      this.clearCounts();
    }

    this.timerId = setTimeout(() => {
      this.clearCounts();
    }, this.interval);
  }

  isDoubleClicked (key, strict = false) {
    return this.keys.includes(key) ? (strict ? this.counts[key] === 2 : this.counts[key] > 1) : false;
  }
}

class TimerMessage {
  constructor (minInterval = 3000, maxInterval = 10000, lettersPerSec = 12) {
    this.message = '';
    this.timer = null;
    this.minInterval = minInterval;
    this.maxInterval = maxInterval;
    this.lettersPerSec = lettersPerSec;
  }
  getPeriod (length, period) {
    if (period) {
      return period;
    }
    const interval = parseInt(length / this.lettersPerSec) * 1000;
    return Math.min(Math.max(interval, this.minInterval), this.maxInterval);
  }
  clear () {
    clearTimeout(this.timer);
    this.timer = null;
    this.message = '';
  }
  set (message, period = null) {
    clearTimeout(this.timer);
    if (!message) {
      this.clear();
      return;
    }

    this.message = message;
    this.timer = setTimeout(() => {
      this.clear();
    }, this.getPeriod(message.length, period));
  }
}

export {
  getMessageLifetime,
  ClickCounter,
  TimerMessage,
};
